<template>
  <el-row class="cs-contentContainer">
    <el-col class="backgroud-gray cs-fullHeight">
      <div class="cs-fullHeight cs-contentContainer-right cs-course-previous">
        <el-tabs
          class="cs-fullHeight"
          v-model="activeTab"
          type="card"
          @tab-click="clickTab"
        >
          <el-tab-pane
            label="速成课表预览"
            name="speedupSchedule"
          >
            <el-row>
              <el-col :span="8">
                <!-- <div class="cs-label-item">
                          <strong><label class="el-form-item__label float-left">学校：</label></strong>
                          <label class="el-form-item__label float-left" v-text="universityName"></label>
                        </div> -->
                <div class="cs-label-item">
                  <strong><label class="el-form-item__label float-left">总课程数量：</label></strong>
                  <label
                    class="el-form-item__label float-left"
                    v-text="totalCourseCount"
                  ></label>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="cs-label-item">
                  <strong><label class="el-form-item__label float-left">已添加课程数量：</label></strong>
                  <label
                    class="el-form-item__label float-left"
                    v-text="scheduledCourseCount"
                  ></label>
                </div>
              </el-col>
              <el-col :span="8">
                <el-select
                  @change='changeDay'
                  v-model="dayofweek"
                  placeholder="请选择"
                  size="medium"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <el-col>
                <courseCalendar
                  :options="{
                    fontSize:'0.6rem',
                    start:GLOBAL.courseScheduleSetting.start,
                    end:GLOBAL.courseScheduleSetting.end,
                    oneDayOnly:true
                  }"
                  ref="speedupCourseCalendar"
                  :schedules="courseSchedules"
                  :selected-day="dayofweek"
                ></courseCalendar>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane
            label="老师课表预览"
            name="teacherSchedule"
          >
            <el-row>
              <el-col :span="8">
                <div class="cs-label-item">
                  <el-select
                    filterable
                    @change='changeTeacher'
                    v-model="selectedTeacher"
                    placeholder="请选择老师"
                    size="medium"
                  >
                    <el-option
                      v-for="item in teacherList"
                      :key="item.Id"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <el-col>
                <courseCalendar
                  v-loading="loadingTeacher"
                  :options="{
                    start:GLOBAL.courseScheduleSetting.start,
                    end:GLOBAL.courseScheduleSetting.end
                  }"
                  ref="teacherCourseCalendar"
                  :schedules="teacherCourseSchedules"
                ></courseCalendar>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-col>
  </el-row>
</template>


<style lang="scss">
.cs-contentContainer {
  .cs-course-previous {
    .el-tabs {
      .el-tabs__header {
        margin: 0;
        .el-tabs__item {
          background-color: #cccccc;
          color: white;
          border: none;
          &.is-active {
            background-color: #006ab4;
          }
        }
      }
      .el-tabs__content {
        padding: 40px;
        background: white;
      }
    }
  }
  .cs-title {
    display: block;
    margin-bottom: 10px;
  }
  .cs-top-label-container {
    margin-bottom: 10px;
    .cs-label-item {
      width: 100%;
      overflow: hidden;
      label {
        line-height: 20px;
      }
    }
  }
  .grid-content {
    margin-top: 15px;
  }
}
</style>

<script>
import courseCalendar from "../../components/courseCalendar";
import { getColorList } from "../../config/mUtils";
import { srcDaysOfWeek } from "../../service/api-base.service";
import { getTeachers } from "../../service/common.service";
import {
  getSpeedupCourseTotalCount,
  getPlanCourseList
} from "../../service/speedupCourse.service";

export default {
  data() {
    return {
      activeTab: "speedupSchedule",
      universityName: "",
      courseSchedules: [],
      courseDataAll: [],
      dayList: srcDaysOfWeek(),
      dayofweek: 1,
      colorList: getColorList(),
      selectedTeacher: "",
      teacherList: [],
      teacherCourseSchedules: [],
      scheduledCourseCount: 0,
      totalCourseCount: 0,
      loadingTeacher: false
    };
  },
  components: {
    courseCalendar
  },
  props: ["plan", "termId"],
  created() {
    this.loadTeacher();
    this.loadCourseSchedule();
    this.changeTeacher(0);
    this.getCourseCount();
  },
  methods: {
    getCourseCount() {
      getSpeedupCourseTotalCount(this.termId, this.plan.Id).then(result => {
        if (!!result && result.success) {
          this.totalCourseCount = result.data;
        }
      });
    },
    loadTeacher() {
      this.selectedTeacher = "";
      getTeachers(this.plan.Id).then(result => {
        if (result && result.success) {
          this.teacherList = result.data;
        } else {
          console.log("failed:getTeachers", result);
        }
      });
    },
    changeDay() {
      this.loadCourseSchedule();
    },
    loadTeacherCourseSchedule(tid) {
      let planId = 0;
      if (!!this.plan) {
        planId = this.plan.Id;
      }
      this.loadingTeacher = true;
      getPlanCourseList(this.termId, planId, tid, true)
        .then(result => {
          if (!!result && result.success) {
            this.loadCourseList(result.data, tid);
          }
          this.loadingTeacher = false;
        })
        .catch(() => {
          this.loadingTeacher = false;
        });
    },
    loadCourseList(courseListAll, teacherId) {
      if (!teacherId){
        this.teacherCourseSchedules = [];
        return;
      }
      let scheduleList = [];
      let courseList = courseListAll.filter(i => i.TeacherId == teacherId);
      let colorList = getColorList();

      courseList.forEach((element, index) => {
        let dayofweek = element.DayOfWeek;
        if (dayofweek == 0) {
          dayofweek = 7;
        }
        let courseName = element.CourseName;
        if (element.CourseClass > 0) {
          courseName += "-分班" + element.CourseClass;
        }
        let desc =
          courseName +
          "<br/>" +
          element.StudentCount +
          "人" +
          "<br/>" +
          element.TeacherName;
        let item = {
          color: colorList[index],
          starttime: element.StartTimeText,
          endtime: element.EndTimeText,
          dayofweek: dayofweek,
          title: desc,
          text: "",
          tooltipText: element.StartTimeText + " - " + element.EndTimeText,
          keyValue: index,
          dataId: index
        };
        scheduleList.push(item);
      });

      this.teacherCourseSchedules = scheduleList;
    },
    changeTeacher(tid) {
      this.loadTeacherCourseSchedule(tid);
    },
    clickTab() {
      if (this.activeTab == "speedupSchedule") {
        this.$refs.speedupCourseCalendar.resize();
      } else {
        this.$refs.teacherCourseCalendar.resize();
      }
    },
    loadCourseSchedule() {
      let scheduleList = [];

      if (this.plan && this.plan.courseList) {
        this.scheduledCourseCount = this.plan.courseList.length;

        let dow = this.dayofweek;
        if (dow == 7) {
          dow = 0;
        }
        let courseList = this.plan.courseList.filter(i => i.DayOfWeek == dow);
        courseList.forEach((element, index) => {
          let dayofweek = element.DayOfWeek;
          if (dayofweek == 0) {
            dayofweek = 7;
          }
          let courseName = element.CourseName;
          if (element.CourseClass > 0) {
            courseName += "-分班" + element.CourseClass;
          }
          let desc =
            courseName +
            "<br/>" +
            element.StudentCount +
            "人" +
            "<br/>" +
            element.TeacherName;

          let subIndex = index % this.colorList.length;
          let color = this.colorList[subIndex];
          let item = {
            color: color,
            starttime: element.StartTimeText,
            endtime: element.EndTimeText,
            dayofweek: dayofweek,
            title: desc,
            text: "",
            tooltipText: element.StartTimeText + " - " + element.EndTimeText,
            keyValue: index,
            dataId: index
          };
          scheduleList.push(item);
        });
      }
     
      this.courseSchedules = scheduleList;
    }
  },
  watch: {
    plan: function() {
      this.loadTeacher();
      this.loadCourseSchedule();
      this.changeTeacher(0);
      this.getCourseCount();
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/components/speedupCourse/schedulePlanPreview.vue